export const ROOT_PATH_APP = '';

export interface Route {
  path: string;
  fullPath: string;
}

export const Routes: Array<Route> = [
  { path: 'dashboard', fullPath: `${ROOT_PATH_APP}/` },
  { path: 'users', fullPath: `${ROOT_PATH_APP}/users` },
  { path: 'test', fullPath: `${ROOT_PATH_APP}/test` },
  { path: 'clients', fullPath: `${ROOT_PATH_APP}/clients` },
  { path: 'sales-opportunities', fullPath: `${ROOT_PATH_APP}/sales-opportunities` },
  { path: 'campaigns', fullPath: `${ROOT_PATH_APP}/campaigns` },
  { path: 'activities', fullPath: `${ROOT_PATH_APP}/activities` },
  { path: 'offers', fullPath: `${ROOT_PATH_APP}/offers` },
  { path: 'reservations', fullPath: `${ROOT_PATH_APP}/reservations` },
  { path: 'assignments', fullPath: `${ROOT_PATH_APP}/assignments` },
  { path: 'application-settings', fullPath: `${ROOT_PATH_APP}/application-settings` },
  { path: 'profile', fullPath: `${ROOT_PATH_APP}/profile` },
  { path: 'profile-edit', fullPath: `${ROOT_PATH_APP}/profile-edit` },
  { path: 'notifications', fullPath: `${ROOT_PATH_APP}/notifications` },
]

export const getFullRouteByPath = (path: string) =>
  Routes.find((r: Route) => r.path === path)?.fullPath;
